export interface IMessage {
  amountString: string;
  amountValue: number;
  author: string;
  authorUrl: string;
  badgeUrl: string;
  bgColor: number;
  currency: string;
  currency_name: string;
  datetime: string;
  id: number;
  message: string;
  messageEx: string;
  messageId: string;
  state: string;
  streamName: string;
  type: string;
}

export interface IStream {
  name: string;
  videoId: string;
  task: string;
  heartbeat: string;
  includeSponsors: boolean;
}

export interface IStreamList {
  streams: IStream[];
}

export interface MessageEmoji {
  id: string,
  txt: string,
  url: string
}

export function messageDeExer(input: string): string {
  //turn json string into array of strings and MessageEmoji
  const inputArray = JSON.parse(input) as (string | MessageEmoji)[];
  return inputArray.map((item) => {
    if (typeof item === "string") {
      return item;
    }
    // If item.id is an emoji, return the emoji, otherwise return the text
    return item.id.charCodeAt(0) > 255 ? item.id : "";
  }).join("");
}
